var _path, _path2, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCylinderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.598145 14.3827C0.598145 14.3828 0.598145 14.3828 0.598145 14.3828C0.598145 15.6277 3.31839 16.6368 6.67399 16.6368C10.0296 16.6368 12.7498 15.6277 12.7498 14.3828C12.7498 14.3828 12.7498 14.3828 12.7498 14.3827H11.7325C11.7326 14.3828 11.7326 14.3828 11.7326 14.3828C11.7127 14.4105 11.6767 14.4525 11.613 14.5084C11.4299 14.669 11.1073 14.8592 10.6225 15.0391C9.66046 15.3959 8.26466 15.6368 6.67399 15.6368C5.08332 15.6368 3.68753 15.3959 2.72553 15.0391C2.24069 14.8592 1.91813 14.669 1.735 14.5084C1.6713 14.4525 1.63525 14.4105 1.61535 14.3828C1.61538 14.3828 1.61541 14.3828 1.61544 14.3827H0.598145ZM11.7554 14.4227C11.7556 14.4227 11.7551 14.4208 11.7534 14.417C11.7544 14.4208 11.7553 14.4227 11.7554 14.4227ZM1.59455 14.417C1.59286 14.4208 1.59236 14.4227 1.59254 14.4227C1.59272 14.4227 1.59357 14.4208 1.59455 14.417Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.0983 2.49809C1.0983 2.61279 1.15925 2.78357 1.40547 2.99952C1.65076 3.21466 2.03448 3.43119 2.55178 3.62309C3.58254 4.00546 5.03992 4.25204 6.67415 4.25204C8.30839 4.25204 9.76577 4.00546 10.7965 3.62309C11.3138 3.43119 11.6975 3.21466 11.9428 2.99952C12.1891 2.78357 12.25 2.61279 12.25 2.49809C12.25 2.38339 12.1891 2.2126 11.9428 1.99665C11.6975 1.78152 11.3138 1.56499 10.7965 1.37309C9.76577 0.990712 8.30839 0.744141 6.67415 0.744141C5.03992 0.744141 3.58254 0.990712 2.55178 1.37309C2.03448 1.56499 1.65076 1.78152 1.40547 1.99665C1.15925 2.2126 1.0983 2.38339 1.0983 2.49809Z",
    stroke: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1.0166,
    height: 11.8862,
    transform: "matrix(-1 0 0 1 12.75 2.5)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.02,
    height: 11.8862,
    transform: "matrix(-1 0 0 1 1.61816 2.5)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCylinderIcon);
export default __webpack_public_path__ + "static/media/cylinder-icon.ea63fcef32118637e983307faf441580.svg";
export { ForwardRef as ReactComponent };